import type { UpdateLaunchMode } from "@features/updater";

interface RuntimeBoot {
  holdLocalDiagnostics: () => void;
  detectBootMode: () => Promise<UpdateLaunchMode>;
  startNormalRuntime: () => void;
  render: () => void;
}

/**
 * Native boot mode is known before any network/media/user runtime starts.
 * Rendering still happens after a failed lookup so the local diagnostic screen
 * can explain recovery instead of leaving a blank window.
 */
export async function startFrontendRuntime(boot: RuntimeBoot): Promise<UpdateLaunchMode> {
  boot.holdLocalDiagnostics();

  let mode: UpdateLaunchMode = "failed";
  try {
    mode = await boot.detectBootMode();
  } finally {
    if (mode === "normal") boot.startNormalRuntime();
    boot.render();
  }
  return mode;
}
